import React, {Component} from "react";

import {View, Text, TextInput}  from 'react-native';

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'

import Botao from '../componentes/Botao'

import RotuloErro from '../componentes/RotuloErro'

import {ITEM_TIPO_PRODUTO, ITEM_TIPO_SERVICO, QUANT_MAX_FOTOS_PRODUTOS} from '../util/constantes'

import CampoNumero from '../componentes/CampoNumero'

import ComponenteCategoria from '../componentes/ComponenteCategoria'

import Combo from '../componentes/Combo'

import Imagem from '../componentes/Imagem'

import Bloco from '../componentes/Bloco'

import {carregamento} from '../componentes/Carregamento'

import * as util from '../util/util'

import {removerImagemItem} from '../ws/ws_imagens_itens'

import {semDados} from '../componentes/SemDados'

import Upload from '../componentes/Upload'

import {salvarImagemItem} from '../ws/ws_imagens_itens'

import Alerta from '../componentes/Alerta'





export default class FormularioItem extends Component {

	
	constructor(props) {
        
        super(props);
		
		this.state = {
			id: null,
			tipo: ITEM_TIPO_PRODUTO,
			nome: null,
			descricao: null,
			tags: null,
			valor: 0,
			marca: null,
			modelo: null,
			cor: null,
			tamanho: null,
			obs: null,
			msgErro: null,
			imagensAtuais: [],
			sincronizando: false
        };
		
		this.btSalvarRef = React.createRef();
		
		this.componenteCategoriaRef = React.createRef();

		this.diaExclusaoRef = React.createRef();
		
		this.cbTipoRef = React.createRef();
    }
	
	
	setDados(item, imagensAtuais){

		this.setState({id: item.id});
        this.setState({tipo: item.tipo});
		this.setState({nome: item.nome});
		this.setState({descricao: item.descricao});
		this.setState({tags: item.tags});
		this.setState({valor: item.valor==null?0:item.valor});
		this.setState({marca: item.marca});
		this.setState({modelo: item.modelo});
		this.setState({cor: item.cor});
		this.setState({tamanho: item.tamanho});
		this.setState({obs: item.obs});
		this.setState({imagensAtuais: imagensAtuais!=null?imagensAtuais:[]});

		if(this.componenteCategoriaRef.current)
			this.componenteCategoriaRef.current.setDados(item.tipo, item.fk_categoria, item.fk_subcategoria);
		
		if(this.componenteCategoriaRef.current)
			this.cbTipoRef.current.setIdSelecionado(item.tipo);
    }
	
	
	getDados(){

		let categoria = this.componenteCategoriaRef.current.getDados();

		return {
			id_item: this.state.id_item,
			tipo: this.state.tipo,
			nome: this.state.nome,
			descricao: this.state.descricao,
			tags: this.state.tags,
			id_categoria: categoria!=null?categoria.id_categoria:null,
			id_subcategoria: categoria!=null?categoria.id_subcategoria:null,
			valor: this.state.valor,
			marca: this.state.marca,
			modelo: this.state.modelo,
			cor: this.state.cor,
			tamanho: this.state.tamanho,
			obs: this.state.obs	
        };
    }
	
	
	validar(){
		
		this.btSalvarRef.current.setCarregando(true)
        
		this.setState({msgErro: null});
	
		const { salvar } = this.props;
		
        if(texto.isBlanck(this.state.nome)){

            this.salvarErro("Informe o nome do producao/Serviço.");
            return;
        } 

		if(texto.isBlanck(this.state.descricao)){

            this.salvarErro("Informe a descrição do producao/Serviço.");
            return;
        }
		
		let categoria = this.componenteCategoriaRef.current.getDados();
		
		if(categoria==null || texto.isBlanck(categoria.id_categoria)){

            this.salvarErro("Selecione a categoria do producao/Serviço.");
            return;
        }
		
        salvar({"nome": this.state.nome, 
					"tipo": this.state.tipo, 
						"descricao": this.state.descricao, 
							"tags": this.state.tags,
								"id_categoria": categoria.id_categoria,
									"id_subcategoria": categoria.id_subcategoria,
										"valor": this.state.valor,
									"marca": this.state.marca,
								"modelo": this.state.modelo,
							"cor": this.state.cor,
						"tamanho": this.state.tamanho,
					"obs": this.state.obs});
	}


	salvarErro(mensagem){
		
        this.btSalvarRef.current.setCarregando(false);
		this.setState({msgErro: mensagem});
    }


	salvarSucesso(){
		
		this.btSalvarRef.current.setCarregando(false)
		this.setState({msgErro: null});
	}
	
	
	mudouTipo(novoTipo){
		
		this.setState({tipo: novoTipo.id})
		
		this.componenteCategoriaRef.current.setDados(novoTipo.id, null, null);	
	}

	
	mostrarImagens(){
		
		if(this.state.imagensAtuais.length== 0)
			return(semDados("image", "Você ainda não enviou nenhuma foto", 60))
		else
			return (
				<View style={[estilos.grade, {alignItems:'center'}]}>
					{this.state.imagensAtuais.map((item, index) => 
						<View key={index} style={{alignItems:'center'}}>   
							<Imagem imagem={item.menor} tamanho={80} style={{margin:5}}/>
							<Botao 
								acao={()=>this.preparaParaRemoverImagem(item)}
								somente_texto={true}
								texto="Remover"/> 
						</View>)
					}					
				</View>)
	}


	preparaParaRemoverImagem= async (item)=>{

		util.print("preparaParaRemoverImagem "+item.id);
	
		Alerta("Exclusão de Foto", "Deseja realmente excluir esta foto?", async ()=>{
			await this.removerImagem(item.id);
		})
	}


	async removerImagem(id){

		util.print("remover "+id);
		
		this.setState({sincronizando: true});

		await removerImagemItem(id);
		
		let lista = [];

		this.state.imagensAtuais.map(async (aux) => {

			if(aux.id != id)
				lista.push(aux)	
		});
		
		this.setState({imagensAtuais: lista});

		this.props.excluirFoto(id);

		this.setState({sincronizando: false});
	}


	async enviarImagem(arquivo){
		util.print("ok2");
		await salvarImagemItem(this.state.id, arquivo);
		util.print("ok3");
		
		this.props.recarregar();
	}


    render() {
		return(
			<View>  	
				<Bloco todaArea={true}>  

					<View style={{marginTop:10}}/>   

					<Combo 
						mostrarVazio = {false}
						selecionado={this.state.tipo}
						rotulo="Tipo:"
						dados={[{'id': ITEM_TIPO_PRODUTO, 'nome': "Produto"}, 
						{'id': ITEM_TIPO_SERVICO, 'nome': "Serviço"}]} 
						aoMudar={(valor)=>this.mudouTipo(valor)}
						ref={this.cbTipoRef}/>

					<View style={{marginTop:30}}/> 
									
					<Text style={estilos.rotulo_padrao}>Título/None:</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={false}
						onChangeText={(text)=>this.setState({nome: text})}
						maxLength={150}
						value={this.state.nome}/>
			
					<View style={{marginTop:30}}/> 
																		
					<Text style={estilos.rotulo_padrao}>Descrição:</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={true}
						numberOfLines = {4}
						onChangeText={(text)=>this.setState({descricao: text})}
						maxLength={250}
						value={this.state.descricao}/>
					
					<View style={{marginTop:30}}/>
					
					<Text style={estilos.rotulo_padrao}>Palavras-chaves:</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={false}
						onChangeText={(text)=>this.setState({tags: text})}
						maxLength={250}
						value={this.state.tags}/>
					
					<View style={{marginTop:30}}/>
					
					<ComponenteCategoria ref={this.componenteCategoriaRef}/>
					
					<View style={{marginTop:30}}/>
					
					<Text style={estilos.rotulo_padrao}>Preço (opcional):</Text>
						
					<CampoNumero
						valor={this.state.valor}
						setValor={(valor) => this.setState({valor: valor})}
						prefixo={"R$: "}/>
					
					<View style={{marginTop:30}}/>
					
					<Text style={estilos.rotulo_padrao}>Marca/Fabricante (opcional):</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={false}
						onChangeText={(text)=>this.setState({marca: text})}
						maxLength={250}
						value={this.state.marca}/>
					
					<View style={{marginTop:30}}/>
					
					<Text style={estilos.rotulo_padrao}>Modelo (opcional):</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={false}
						onChangeText={(text)=>this.setState({modelo: text})}
						maxLength={250}
						value={this.state.modelo}/>
					
					<View style={{marginTop:30}}/>
					
					<Text style={estilos.rotulo_padrao}>Cor (opcional):</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={false}
						onChangeText={(text)=>this.setState({cor: text})}
						maxLength={250}
						value={this.state.cor}/>
					
					<View style={{marginTop:30}}/>
					
					<Text style={estilos.rotulo_padrao}>Tamanho/Dimensões (opcional):</Text>
								
					<TextInput
						placeholder=""
						style={estilos.campo_padrao} 
						multiline={false}
						onChangeText={(text)=>this.setState({tamanho: text})}
						maxLength={250}
						value={this.state.tamanho}/>
					
					<View style={{marginTop:20}}/>
				</Bloco> 	
				
				{this.state.id !=null &&
					<Bloco>  			
						<View style={{marginTop:10}}/> 

						{this.state.sincronizando?
							(carregamento(this.state.sincronizando)):
							(<View style={{alignItems:'center'}}>
								<View style={{marginTop:10}}/>  
								
								<Text style={estilos.rotulo_titulo}>Fotos do Produto/Serviço ({this.state.imagensAtuais.length}/{QUANT_MAX_FOTOS_PRODUTOS})</Text>	    
									
								<View style={{marginTop:20}}/>  
										
								{(this.mostrarImagens())}
								
								{((this.state.imagensAtuais.length) < QUANT_MAX_FOTOS_PRODUTOS) &&
									
									<View style={{alignItems:'center'}}>
										<View style={{marginTop:20}}/> 
										<View style={estilos.separador}/>
										<View style={{marginTop:20}}/>
										<Upload acaoRecebimentoArquivo={(arquivo)=>this.enviarImagem(arquivo)}/>
									</View>	  
								}
							</View>)
						}
						<View style={{marginTop:10}}/>  
					</Bloco>
				}		
				<Bloco>  		
					<View style={{marginTop:10}}/>
					
					{util.temConteudo(this.state.msgErro) && 
						<View style={{alignItems:'center'}}>
							<RotuloErro mensagem={this.state.msgErro}/>
						</View>
					}
					
					<View style={{alignItems:'center'}}>
						<Botao 
							acao={()=>this.validar()}
							texto="Salvar Produto/Serviço"
							ref={this.btSalvarRef}/>    
					</View>

					<View style={{marginTop:10}}/>

					{this.state.id ==null &&
						<View style={{alignItems:'center'}}>
							<View style={{marginTop:20}}/>
							<Text style={estilos.rotulo_menor}>Após salvar, você poderá enviar as fotos do item cadastrado.</Text>
							<View style={{marginTop:10}}/>
						</View>	
					}
					<View style={{marginTop:10}}/>
				</Bloco> 
			</View>
		)
   }
} 